module.exports = __webpack_public_path__ + "img/orfeo_logo.e6bdc52c.png";